var map = {
	"./alpamare.png": 1548,
	"./bcge.png": 5192,
	"./buhler.png": 2665,
	"./clienia.png": 5273,
	"./confiseur_laderach_ag.png": 6459,
	"./csl_behring.png": 703,
	"./ems_chemie.png": 6787,
	"./grand_resort_bad_ragaz.png": 896,
	"./griesser.png": 5968,
	"./helvetia.png": 1094,
	"./herisau_psychiatrie.png": 1705,
	"./hilti.png": 5742,
	"./hitachi_baden.png": 1841,
	"./hitachi_zurich.png": 1256,
	"./hotelplan_suisse.png": 4691,
	"./huber_suhner.png": 473,
	"./kantonsspital-right.png": 9802,
	"./kantonsspital.png": 2733,
	"./leica.png": 7651,
	"./logistic_zentrum.png": 4725,
	"./lonza.png": 9957,
	"./metrohm.png": 9314,
	"./mobiliar.png": 4408,
	"./omega.png": 5226,
	"./post-finance.png": 5472,
	"./post_finance.png": 8905,
	"./post_verteilzentrum.png": 6160,
	"./rolex.png": 2765,
	"./spital_grabs.png": 9068,
	"./spital_herisau.png": 3262,
	"./spital_musnterlingen.png": 8459,
	"./stadler_bussnang.png": 9484,
	"./sunrise.png": 4115
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2262;